import React from 'react';

/**
 * Animated Background Component
 * Pulsing gradient blobs for modern aesthetic
 */
export const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl animate-pulse" />
      <div 
        className="absolute top-1/2 -left-40 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl animate-pulse" 
        style={{ animationDelay: '1s' }} 
      />
      <div 
        className="absolute -bottom-40 right-1/3 w-72 h-72 bg-violet-500/10 rounded-full blur-3xl animate-pulse" 
        style={{ animationDelay: '2s' }} 
      />
    </div>
  );
};

export default AnimatedBackground;

